var $ = require('../../modules/$');
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-dock-monitor/~/babel-runtime/~/core-js/library/fn/object/define-property.js
 ** module id = 298
 ** module chunks = 0
 **/